import { RegisterOptions, useFormContext } from "react-hook-form";

import { TextAreaInput, TextAreaInputProps } from "./TextAreaInput";

type RhfTextAreaInputProps = TextAreaInputProps & {
  name: string;
  rhfOptions?: RegisterOptions;
  className?: string;
};

export const RhfTextAreaInput = (props: RhfTextAreaInputProps): JSX.Element => {
  const { register, formState } = useFormContext();
  const registerResult = register(props.name, props.rhfOptions);

  return (
    <div className={props.className}>
      <TextAreaInput {...props} inputProps={registerResult} />
      {
        <p className="text-xs text-red-500 mt-1 ml-1">
          {formState.errors[props.name]?.message?.toString() ?? ""}
        </p>
      }
    </div>
  );
};
